module.exports = require('preact-compat').createClass;
